import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class SalaryGridForm extends ObjetKForm {
  code: string = ''
  label: string = ''
  order: number = 0
  professionId?: number
  effectiveDate: string = ''
  description: string = ''

  static validationRules = {
    code: combineRules(requiredRule('Le code est obligatoire')),
    label: combineRules(requiredRule('Le libellé est obligatoire')),
    effectiveDate: combineRules(requiredRule("La date d'effet est obligatoire"))
  }

  constructor(data?: Partial<SalaryGridForm>) {
    super(data)
    if (data) {
      this.code = data.code ?? ''
      this.label = data.label ?? ''
      this.order = data.order ?? 0
      this.professionId = data.professionId
      this.effectiveDate = data.effectiveDate ?? ''
      this.description = data.description ?? ''
    }
  }
}
